// jQuery free
import {onDOMReady} from './dom';
import {SCREEN_DESKTOP} from './layoutUnits';
import StickySidebar from 'sticky-sidebar/src/sticky-sidebar';

onDOMReady(function () {
    const sidebarLayoutSidebar = document.getElementsByClassName('sidebarLayout__sidebar');

    if (!sidebarLayoutSidebar.length) {
        return;
    }

    if (!sidebarLayoutSidebar[0].getAttribute('data-is-sticky')) {
        return;
    }

    const sidebarLayoutSidebarSticky = sidebarLayoutSidebar[0].getElementsByClassName('sidebarLayout__sidebar__sticky')[0];
    const sidebarLayoutSidebarInner = sidebarLayoutSidebar[0].getElementsByClassName('sidebarLayout__sidebar__inner')[0];
    const sidebarLayoutMain = document.getElementsByClassName('sidebarLayout__main')[0];
    const sidebarLayout = sidebarLayoutSidebar[0].parentElement;

    if (!sidebarLayoutSidebarSticky || !sidebarLayoutSidebarInner || !sidebarLayoutMain || !sidebarLayout) {
        return;
    }

    const sidebarLayoutStyles = window.getComputedStyle(sidebarLayout);
    const topSpacing = parseInt(sidebarLayoutStyles.paddingTop, 10) || 0;
    const bottomSpacing = parseInt(sidebarLayoutStyles.paddingBottom, 10) || 0;

    let stickySidebar = null;
    let resizeTimeoutId = null;

    const destroyStickySidebar = () => {
        if (!stickySidebar) {
            return;
        }

        stickySidebar.destroy();
        stickySidebar = null;
    };

    const shouldEnableStickySidebar = () => {
        if (window.innerWidth < SCREEN_DESKTOP) {
            return false;
        }

        return sidebarLayoutSidebarInner.offsetHeight < sidebarLayoutMain.offsetHeight;
    };

    const createStickySidebar = () => {
        stickySidebar = new StickySidebar('.sidebarLayout__sidebar', {
            innerWrapperSelector: '.sidebarLayout__sidebar__sticky',
            containerSelector: '.sidebarLayout',
            topSpacing,
            bottomSpacing,
            resizeSensor: false,
            minWidth: SCREEN_DESKTOP - 1
        });
    };

    const reconcileStickySidebar = () => {
        if (!shouldEnableStickySidebar()) {
            destroyStickySidebar();
            return;
        }

        if (!stickySidebar) {
            createStickySidebar();
            return;
        }

        stickySidebar.updateSticky({type: 'resize'});
    };

    const scheduleReconcileStickySidebar = () => {
        clearTimeout(resizeTimeoutId);
        resizeTimeoutId = window.setTimeout(reconcileStickySidebar, 75);
    };

    window.updateStickySidebar = scheduleReconcileStickySidebar;
    window.addEventListener('resize', scheduleReconcileStickySidebar, {passive: true, capture: false});

    const resizeObserver = new ResizeObserver(scheduleReconcileStickySidebar);
    resizeObserver.observe(sidebarLayoutSidebarInner);
    resizeObserver.observe(sidebarLayoutMain);

    reconcileStickySidebar();
});
